import React, { useState, useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import router from "routes";
import { get } from "util/requests";
import colors from "colors";
import moment from "moment";
import { deviations_columns } from "../../edc_grid/components/deviations_view";
import { useSelector } from "react-redux";

export default function AETable(props) {
  const [events, setEvents] = useState([]);
  const permissions = useSelector((state) => state.user.userData.permissions);
  const active_study_id = useSelector((state) => state.study.active_study_id);

  useEffect(() => {
    get("/deviations").then((ret) => setEvents(ret.data));
  }, []);

  let columns = [...deviations_columns(permissions)];
  columns.unshift({
    field: "subject_id",
    headerName: "Subject ID",
    width: 160,
    align: "center",
    headerAlign: "center",
  });

  return (
    <DataGrid
      rows={events}
      columns={columns}
      disableColumnSelector
      disableRowSelectionOnClick
      disableColumnMenu
      pageSize={10}
      rowsPerPageOptions={[10]}
      hideFooterSelectedRowCount
      pageSizeOptions={[10]}
      columnHeaderHeight={34}
      rowHeight={34}
      autoPageSize
      initialState={{
        pagination: {
          paginationModel: {
            pageSize: 10,
          },
        },
      }}
      sx={{
        boxShadow: 0,
        border: 1,
        borderColor: "#f0f0f0",
        "& .MuiDataGrid-cell:hover": {
          color: "#8349fd",
          cursor: "pointer",
        },
        "& .MuiDataGrid-topContainer .MuiDataGrid-columnHeader ": {
          // backgroundColor: "#f7f3fe",
          backgroundColor: colors.table_header_background,
        },
        "& .MuiDataGrid-topContainer .MuiDataGrid-filler ": {
          // backgroundColor: "#f7f3fe",
          backgroundColor: colors.table_header_background,
        },
        "& .MuiDataGrid-columnHeaderTitle": {
          fontWeight: 700,
          color: "#333",
        },
        "& .MuiDataGrid-cell:focus": {
          outline: "none", // Remove the focus outline
        },
      }}
      onRowClick={(data) => {
        if (data.row.source === "auto") {
          data.row.pathname && router.navigate(data.row.pathname);
        } else if (data.row.source === "manual") {
          router.navigate(`/subjects/${data.row.subject_id}/deviation`);
        }
      }}
    />
  );
}
